module.exports = __webpack_public_path__ + "static/img/pay_alipay@3x.52c6362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_alipay@3x.png
// module id = E1jo
// module chunks = 1